
import { Button } from "../components/ui/button"
import { X } from "lucide-react"
import { useState } from "react"
import useSWRMutation from "swr/mutation";
import { handleMutation, handleUpdates } from "../util/axiosConfig";
import { message } from "antd";
import Switch from "./Switch"
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../components/ui/LoadingSpinner";

export function UserDetailsCard({ selectedUser }: { selectedUser?: Renter }) {
  const [switchValue, setSwitchValue] = useState<boolean>(selectedUser?.status === 'active');
  const navigate = useNavigate()

  const { trigger: toggleStatus, isMutating: updatingStatus } = useSWRMutation(`newAdmin/users/renter/${selectedUser?.id}/toggle-status`, handleMutation);

  const goToTransactions = () => {
    navigate(`/admin/users/${selectedUser?.id}/renter/transactions`);
  }

  const toggleSwitch =  async () => {
    if (!selectedUser) return;
    try {
      const response = await toggleStatus({
        status: switchValue ? "inactive" : "active",
      });
      console.log({ response });
      message.success("User Status updated");
    } catch (error) {
      console.error("Error updating status:", error);
    }
  }

  return (
    <div className="border rounded-lg overflow-hidden bg-white">
      <div className="bg-blue-200 p-4 flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-blue-800 flex items-center justify-center">
          <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2 className="text-xl font-medium text-blue-800 capitalize">{selectedUser?.name}</h2>
      </div>

      <div className="p-5 space-y-5">
        <div>
          <div className="text-gray-700 font-medium mb-1">Status</div>
          <div className="flex items-center gap-2">
            <Switch
              switchValue={switchValue}
              setSwitchValue={(value: any) => {
                setSwitchValue(value);
                void toggleSwitch()
              }}
            />
            {
              switchValue ? <span className="text-blue-600 font-medium">Active</span> :
                <span className=" text-gray-400 font-medium">Inactive</span>
            }
            {updatingStatus && <LoadingSpinner color="grey" />}
          </div>
        </div>

        <div>
          <div className="text-gray-500">{selectedUser?.email}</div>
        </div>

        <div className="flex items-center gap-1">
          <span className="text-blue-600 text-xl font-bold">{selectedUser?.totalCompletedRentals}/{selectedUser?.totalRentals}</span>
          <span className="text-gray-500">Request Completed</span>
        </div>

        <div>
          <div className="text-blue-600">
            {selectedUser?.address}
          </div>
        </div>

        <Button variant="link" className=" bg-transparent text-amber-500 p-0 underline" onClick={() => goToTransactions()}>
          View Transactions
        </Button>

        {/* <div>
          <Button
            variant="ghost"
            className="bg-transparent flex items-center gap-1 p-0 hover:bg-transparent hover:text-blue-600"
            onClick={regenerateKey}
          >
            <RefreshCw className="h-4 w-4" />
            <span>Regenerate Access Credentials</span>
          </Button>
        </div> */}
      </div>
    </div>
  )
}


function ManageUser({ selectedUser, handleClosePanel }: { selectedUser?: Renter, handleClosePanel?: () => void }) {
  return (
    <div key={selectedUser?.id} className="bg-white rounded-lg shadow p-4 transition-all duration-300">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-blue-600">Manage User</h2>
        <Button variant="ghost" size="icon" onClick={handleClosePanel} className="hover:bg-gray-100">
          <X className="h-5 w-5 text-red-500" />
        </Button>
      </div>
      <UserDetailsCard selectedUser={selectedUser} />
    </div>
  );
}

export default ManageUser;